<template>
    <div class="row">
        <div class="w-100 px-5 py-4">
        <div class="col-12">
          <h1>ADMINISTRA TUS COMUNICADOS</h1>
          <h4>Ingrese la información requerida para agregar y/o editar los comunicados de tu Micrositio</h4>
        </div>
        
        <div class="col-12 contenedor-form">
        <h5>Selecciona tu micrositio para editar y/o agregar Comunicados</h5>
        <hr />
        <div class="div_opciones">
        <h6 style="padding: 5px">Micrositio</h6>
        <div class="div-select">
        <C001PaginasDeInicio
        v-on:valorParaElPadre="cambioTipoDePagina"  
        :prefijo="enumeraciones.etiquetasDeHTML.Select" 
        :tipo="enumeraciones.tiposDeSelect.Seleccione" 
        :idDelInput="'catalogoPaginaPasoUno'" 
        :parametros="{PaginaDeInicioId: null,MenuId: null,SubmenuId: null,TipoContenedorId: null,ConPaginaDeInicio: false,ConMenu: false,ConSubmenu: false, ConSecciones: false, ConInactivas:false, SoloPermiteSubirContenido: true}" 
        :valorDefinido="tipoDePaginaWebId">
        </C001PaginasDeInicio>
        </div>
        <div v-if="micrositioSeleccionado" class="ver-comunicados">
        <button type="button" class="btn btn-success" @click="obtenerComunicados"><i class="fa fa-eye"></i>&nbsp;&nbsp;Ver Comunicados</button>
        </div>
        </div>
        </div>
        <div class="col-12 contenedor-form">
         <div v-if="botonAgregarComunicado">
          <button type="button" class="btn btn-sm btn btn-light" data-toggle="modal" data-target="#exampleModalLong" @click="nuevoComunicado()"><i class="fas fa-image"></i>&nbsp;&nbsp;Agregar Comunicado</button>&nbsp;&nbsp;&nbsp;&nbsp;
          <button v-if="$store.getters.Get_SICPO_Micrositio_ComunicadosOrden.length!=0" type="button" class="btn btn-sm btn btn-info" data-toggle="modal" data-target="#exampleModalLong" @click="ordenarComunicado()"><i class="fas fa-list-ol"></i>&nbsp;&nbsp;Ordenar Comunicados</button>
        </div>
                 <div id="comunicados">
                          <table
                            class="table table-striped table-light table-hover"
                            id="tabla-comunicados"              
                            data-toggle="table"
                            data-pagination="true"
                            data-undefined-text="Sin información"  
                            data-page-size = "5"
                            data-page-list="[5,10,20]"
                            data-click-to-select="false"
                            data-search="true"
                            >
                            
                            <thead class="thead-green">
                                <tr>
                                   
                                    <th data-halign="center" data-width="10" data-align="center" data-field="ComunicadoMicrositio" data-sortable="true">
                                        Folio
                                    </th>
                                     <th data-halign="center" data-width="30" data-align="center" data-field="Titulo"  data-sortable="true">
                                        Titulo
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="ImagenFormato"  data-sortable="true">
                                        Imagen
                                    </th>
                                     <th data-halign="center" data-width="20" data-align="center" data-field="ArchivoFormato"  data-sortable="true">
                                        Ruta
                                    </th>                                
                                     <!-- <th data-halign="center" data-width="20" data-align="center" data-field="Orden"  data-sortable="true">
                                        Orden
                                    </th> -->
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaPublicacionFormato" data-sortable="true">
                                        Fecha de Publicacion
                                    </th>
                                    <th data-halign="center" data-width="20" data-align="center" data-field="FechaFinDePublicacionFormato" data-sortable="true">
                                        Fecha Final de Publicacion
                                    </th>
                                    <th data-events="operateEvents" data-halign="center" data-width="20" data-align="center" data-field="EstaActivo.html" data-sortable="true">
                                        Estado
                                    </th>
                                    <th data-events="operateEvents" data-width="40"  data-halign="center" data-align="center" :data-formatter="this.agregarAccionEditar()">
                                        Editar
                                    </th>
                                      
                                    
                                </tr> 
                            </thead>
                        </table>
                    </div>
        </div>
      
        </div>


<!-- Modal -->
<div class="modal fade bd-example-modal-lg" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
        <div v-if="mostrarFormulario">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Agregar Comunicado</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body form-comunicado">
      <div class="caja-input">    
        <h6>Ingrese un Título *</h6>
        <input type="text" id="texto_vinculo_contenido" class="form-control" v-model="titulo" @keyup=" validarPorCampo('texto_vinculo_contenido',titulo)" placeholder="Ingrese titulo de la descripcion del textoo" />
        </div>
        <div class="caja-input">
        <div v-if="nombreDeImagen!=null">
            <h6>Imagen Actual *</h6>
            <label>{{nombreDeImagen}}</label><br>
        </div>
        <h6>Seleccione Imagen *</h6>
        <input type="file" id="imagen_contenido" @click="validarPorCampo('imagen_contenido',IMAGEN_COMUNICADO)"  @change="subirImagen($event)" accept=".JPEG,.JPG,.PNG" />
      </div>
  <hr /> 
   <h6>Seleccione la accion del Comunicado</h6>    
<div class="form-check caja-input">
  <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="descargar-documento" @click="radioSeleccionado(1)"  :checked="esDocumento?true:false"/>
  <label class="form-check-label" for="flexRadioDefault1">
    Descargar Documento
  </label>
</div>
<div class="form-check caja-input">
  <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="pagina-micrositio" @click="radioSeleccionado(2)"  :checked="esPaginaMicrositio?true:false"/>
  <label class="form-check-label" for="flexRadioDefault2">
    Ir a una pagina del Micrositio
  </label>
</div>   
<div class="form-check caja-input">
  <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="pagina-externa" @click="radioSeleccionado(3)"  :checked="esPaginaExterna?true:false"/>
  <label class="form-check-label" for="flexRadioDefault2">
    Ir a una pagina externa
  </label>
</div>
<div class="form-check caja-input">
  <input class="form-check-input radio" type="radio" name="flexRadioDefault" id="sin-accion" @click="radioSeleccionado(4)"  :checked="noHacerNada?true:false"/>
  <label class="form-check-label" for="flexRadioDefault2">
    No hacer nada
  </label>
</div>      
<hr />         
<div v-if="esDocumento" class="caja-input">
    <div class="btn-group btn-group-toggle linea-horizontal caja-campos" data-toggle="buttons">
    <label class="btn btn-secondary " :class="[!visualizarEnVisor?'active':'' ]" @click="visualizarEnVisor=false">
    <input type="radio" name="options" id="noEsVisualizado" autocomplete="off"  checked>Descargar Directamente
    </label>
    <label class="btn btn-secondary" :class="[visualizarEnVisor?'active':'' ]"  @click="visualizarEnVisor=true">
    <input type="radio" name="options" id="esVisualizado" autocomplete="off" >Visualizar en Visor
    </label>
    
    </div>         
    <div v-if="nombreArchivo!=null"> 
    <h6>Archivo Actual</h6>
    <label>{{nombreArchivo}}</label><br>
    </div>
    <h6>Seleccione el archivo *</h6>
    <input type="file" id="archivo-comunicado"  @click="validarPorCampo('archivo-comunicado',ARCHIVO_COMUNICADO)" @change="subirDocumento($event)"   accept=".PDF" />
</div>
<div v-if="esPaginaExterna" class="caja-input">
    <h6>Ruta de la pagina externa *</h6>
    <input type="text" id="link-paginaexterna" @keyup="validarPorCampo('link-paginaexterna',paginaExterna)" :class="'form-control'" v-model="paginaExterna" placeholder="Ingrese el link de la pagina externa" />

</div>
<div v-if="esPaginaMicrositio" class="caja-input">
    <h6>Pagina Microstio *</h6>
    <div id="select-pagina" @click="validarPorCampo('select-pagina',rutaPaginaMicrositio)">
    <C013PaginasMicrositio style="padding:0; margin:0;" v-on:valorParaElPadre="cambioPaginaDeMicrositio" :prefijo="enumeraciones.etiquetasDeHTML.Select" :tipo="enumeraciones.tiposDeSelect.Seleccione" :idDelInput="'catalogoPaginaMicrositioPasoUno'" :parametros="{PaginaMicrositioId:null,PaginaDeInicioId: micrositioId,MenuId: null,SubmenuId: null,SeccionDeMicrositioId: null,ConSecciones:false,ConPaginaDeInicio: false,ConTipoContenedor: false,ConInactivas:false,FiltrarPorUsuario:true}" :valorDefinido="paginaSeleccionadaId" :key="keySelectpagina+'|M'"></C013PaginasMicrositio>
    </div>
</div>


    <div class="caja-input">
        <h6>Fecha de publicacion</h6>
       <input type="date" id="publicacion" name="trip-start" v-model="fechaInicio"/>
     </div>
    <div class="caja-input">
        <h6>Fecha fin de publicacion</h6>
       <input type="date" id="publicacion-fin" name="trip-start" v-model="fechaFin" />
      </div>
      </div>
      <div class="modal-footer">      
        <button type="button" class="btn btn-primary" @click="guardarContenido()"><i class="fa fa-check"></i>&nbsp;&nbsp;Guardar</button>
         <button type="button" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button> 
      </div>

</div>


    <div v-if="mostrarOrdenamiento" class="orden" >
    <ListaOrdenable></ListaOrdenable>
    <div class="boton-guardar">
     <button type="button" class="btn btn-primary" @click="guardarOrdenComunicados"><i class="fa fa-check"></i>&nbsp;&nbsp;Guardar Orden</button>
     &nbsp;&nbsp;&nbsp;&nbsp;<button type="button" @click="obtenerComunicados()" class="btn btn-danger" data-dismiss="modal"><i class="fa fa-times-circle"></i>&nbsp;&nbsp;Cancelar</button>
    </div>
</div>
    </div>
 
 

 


 
  </div>

</div>
    </div>
</template>

<script>
import C001PaginasDeInicio from '@/components/SICPO/Catalogos/C001PaginaInicio.vue';
 import ListaOrdenable from '@/components/SICPO/Micrositios/ListaOrdenComunicados.vue'
import enumeraciones from '@/../static/js/enumeraciones';
import axios from 'axios';
import api from '@/../static/js/api';
import comun from "@/../static/js/comun";
 import C013PaginasMicrositio from '@/components/SICPO/Catalogos/C013PaginasMicrositio.vue'

export default {
    components: {
            C001PaginasDeInicio,
            C013PaginasMicrositio,
            ListaOrdenable
        },
    data() {        
        return {
            enumeraciones,
            SinComunicados:0,
            tipoDePaginaWebId:-1,
            micrositioId:-1,
            micrositioSeleccionado:false,
            comunicadosFormato:[],
            esDocumento:true,
            esPaginaMicrositio:false,
            esPaginaExterna:false,
            noHacerNada:false,
            fechaInicio:"",
            fechaFin:"",
            paginaExterna:"",
            titulo:"",
            IMAGEN_COMUNICADO:null,
            ARCHIVO_COMUNICADO:null,
            rutaPaginaMicrositio:-1,
            paginaSeleccionadaId:-1,
            keySelectpagina:1,
            nombreDeImagen:null,
            nombreArchivo:null,
            idComunicadoAEditar:-1,
            esEdicion:false,
            estadoDeComunicado:true,
            botonAgregarComunicado:false,
            visualizarEnVisor:false,
            textoAgregarArchivo:'Si esta ópcion es seleccionada podra agregar un archivo para ser descargado desde el carrusel',
            mostrarOrdenamiento:false,
            mostrarFormulario:false,

        }
    },

    methods:{
        guardarOrdenComunicados:function(evento){
            var datosPeticion =this.crearPeticionOrden(this.$store.getters.Get_SICPO_Micrositio_ComunicadosOrden);
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);
            const METODO_API = api.SICPO.sistema.micrositioweb.comunicadosmicrositios.CambiarOrdenComunicadosMicrositios;
            $('#exampleModalLong').modal('hide')
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + METODO_API, datosPeticion,headerPeticion).then(respuesta => {
                 if(respuesta.data.SiHayError){
                     comun.SeEstaCargandoInformacion(false);
                     $('#exampleModalLong').modal('show')
                     comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                 }else{
                     comun.SeEstaCargandoInformacion(false);
                     comun.mensajeDeAlerta("El orden de los comunicados se han modificado con exito", null, null);
                     this.limpiarFormulario();
                     this.obtenerComunicados();
                 }
                 
              })
        },
        crearPeticionOrden:function(comunicados){
            let peticion = {}
            let nuevoOrden = [];
            for (let index = 0; index < comunicados.length; index++) {
                const element = {
                    ComunicadoMicrositio:comunicados[index].ComunicadoMicrositio,
                    Orden:comunicados[index].Orden
                }
                nuevoOrden.push(element);
            }

            peticion = { 
                Comunicados:nuevoOrden,
                esPrueba:false

            }
            return peticion;
        },
        nuevoComunicado:function(){
            this.limpiarFormulario();
        },
        ordenarComunicado:function(){
           // $('#exampleModalLong').modal('hide')
            
           
            this.mostrarOrdenamiento=true;
            this.mostrarFormulario=false;
        
             
        },
        validarPorCampo:function(id,campo){
            console.log(id);
            console.log(campo);
            var respuesta=false;
            var elemento="";
            if(campo == null || campo == "" || campo == -1){
            elemento = "#"+id; 
            $(elemento).addClass('campo-faltante');
            respuesta = false;
            }else{
                 elemento = "#"+id; 
                $(elemento).removeClass('campo-faltante');
                 respuesta = true;
            }

            return respuesta;

        },
        validarFormulario:function(){
        var formularioCorrecto = true;
        
        if(!this.validarPorCampo('texto_vinculo_contenido',this.titulo)){
            formularioCorrecto=false;
        }
        if(this.nombreDeImagen==null && !this.validarPorCampo('imagen_contenido',this.IMAGEN_COMUNICADO)){
            formularioCorrecto=false;
        }
        if(this.nombreArchivo==null && this.esDocumento && !this.validarPorCampo('archivo-comunicado',this.ARCHIVO_COMUNICADO)){
            formularioCorrecto=false;
        }
        if(this.esPaginaExterna && !this.validarPorCampo('link-paginaexterna',this.paginaExterna)){
            formularioCorrecto=false;
        }
        if(this.esPaginaMicrositio && !this.validarPorCampo('select-pagina',this.rutaPaginaMicrositio)){
            formularioCorrecto=false;
        }
            return formularioCorrecto;
        },
        guardarContenido:function(){
            let datosFormulario = new FormData();
if(this.validarFormulario()){
            let comunicado = {
                Titulo:this.titulo,
                FechaDePublicacion:this.fechaInicio,
                FechaFinDePublicacion:this.fechaFin,
                PaginaInicioId:this.micrositioId,
                ComunicadoMicrositio:this.idComunicadoAEditar,
                AbrirEnVisor : this.visualizarEnVisor

            }
            
            datosFormulario.append('imagen',this.IMAGEN_COMUNICADO);
            if(this.esDocumento){
            datosFormulario.append('archivo',this.ARCHIVO_COMUNICADO);
            }
            if(this.esPaginaExterna){
            comunicado.Ruta = this.paginaExterna;
            }
            if(this.esPaginaMicrositio)
            comunicado.Ruta = this.rutaPaginaMicrositio

            var comunicadoJSON = JSON.stringify(comunicado);
            datosFormulario.append('comunicado',comunicadoJSON);
            datosFormulario.append('esPrueba',false);
            datosFormulario.append('esDocumento',this.esDocumento);
            datosFormulario.append('esExterna',this.esPaginaExterna);
            datosFormulario.append('esPaginaMicrositio',this.esPaginaMicrositio);
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, true);

            if(this.esEdicion == false){
                 $('#exampleModalLong').modal('hide')
                const METODO_GUARDAR = api.SICPO.sistema.micrositioweb.comunicadosmicrositios.GuardarComunicadoMicrositio;
                comun.SeEstaCargandoInformacion(true);
                axios.post(api.conexion + METODO_GUARDAR, datosFormulario,headerPeticion).then(respuesta => {
                 if(respuesta.data.SiHayError){
                     comun.SeEstaCargandoInformacion(false);
                     comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                 }else{
                     comun.SeEstaCargandoInformacion(false);
                     comun.mensajeDeAlerta("El comunicado se a guardado con exito", null, null);
                     this.limpiarFormulario();
                     this.obtenerComunicados();
                 }
              
             })
            }

             if(this.esEdicion == true){
                  $('#exampleModalLong').modal('hide')
                   comun.SeEstaCargandoInformacion(true);
                const METODO_EDITAR = api.SICPO.sistema.micrositioweb.comunicadosmicrositios.EditarComunicadoMicrositio;
               
               axios.post(api.conexion + METODO_EDITAR, datosFormulario,headerPeticion).then(respuesta => {
                 if(respuesta.data.SiHayError){
                     comun.SeEstaCargandoInformacion(false);
                     comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                 }else{
                     comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta("El comunicado se a editado con exito", null, null);
                    this.limpiarFormulario();
                    this.obtenerComunicados();
                 }
             })
            }

}else{
     comun.mensajeDeAlerta("Favor de llenar correctamente el formulario", null, null);
}

        },
        limpiarFormulario:function(){
            this.mostrarOrdenamiento=false;
            this.mostrarFormulario=true;
             this.titulo = ""
             this.esEdicion=false;
             this.idComunicadoAEditar=-1;
             this.estadoDeComunicado=true;
             this.fechaInicio = this.formatearFecha();
             this.fechaFin = this.formatearFecha();
             this.ARCHIVO_COMUNICADO = null;
             this.IMAGEN_COMUNICADO = null;
             this.paginaSeleccionadaId = -1;
             this.keySelectpagina = this.keySelectpagina +1;
             this.nombreDeImagen = null;
             this.nombreArchivo = null;
             this.visualizarEnVisor = false;
             this.paginaExterna = null;
             this.radioSeleccionado(1);
             $("#archivo-comunicado").removeClass("campo-faltante");
             $("#imagen_contenido").removeClass("campo-faltante");
             $("#texto_vinculo_contenido").removeClass("campo-faltante");
             $("#link-paginaexterna").removeClass("campo-faltante");
             $("#select-pagina").removeClass("campo-faltante");

            //  $("#descargar-documento").prop("checked",true);
             $("#imagen_contenido").val("");
             $("#archivo-comunicado").val("");
            
           //  $('#exampleModalLong').modal('toggle')
          
        },
        subirDocumento:function(event){         
            this.ARCHIVO_COMUNICADO = event.target.files[0];
            this.validarPorCampo('archivo-comunicado',this.ARCHIVO_COMUNICADO);
        },
        subirImagen:function(event){
            this.IMAGEN_COMUNICADO = event.target.files[0];
            this.validarPorCampo('imagen_contenido',this.IMAGEN_COMUNICADO)

        },
        radioSeleccionado:function(numeroRadio){
            switch (numeroRadio){
                case 1:
                    this.esDocumento=true;
                    this.esPaginaMicrositio=false;
                    this.esPaginaExterna=false;
                    this.noHacerNada = false;
                    break;
                case 2:
                    this.esDocumento=false;
                    this.esPaginaMicrositio=true;
                    this.esPaginaExterna=false;
                    this.noHacerNada = false;
                    break;
                case 3:
                    this.esDocumento=false;
                    this.esPaginaMicrositio=false;
                    this.esPaginaExterna=true;
                    this.noHacerNada = false;
                    break;
                case 4:
                    this.noHacerNada = true;
                    this.esDocumento=false;
                    this.esPaginaMicrositio=false;
                    this.esPaginaExterna=false;

            }
        },
        cambioPaginaDeMicrositio: function(evento){
            this.rutaPaginaMicrositio = evento.target.value;
            this.validarPorCampo('select-pagina',this.rutaPaginaMicrositio);
        },
        cambioTipoDePagina: function (evento) {
            $("#tabla-comunicados").bootstrapTable('removeAll');
            this.botonAgregarComunicado = false;
            this.micrositioSeleccionado = (evento.target.value>0)
            this.micrositioId = evento.target.value;
        },
        obtenerComunicados:function(){
            const METODO_API = api.SICPO.sistema.micrositioweb.comunicadosmicrositios.ObtenerComunicadosMicrositios;
            var parametros = {
                PaginaInicio:this.micrositioId,
                SoloActivos:false,
                EntreFechas:false,
                EsPrueba:false
          }
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + METODO_API,parametros).then((respuesta)=>{
                if(respuesta.data.SiHayError) {
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                else{ 
                    comun.SeEstaCargandoInformacion(false);         
                    this.$nextTick(async () => {
                        this.botonAgregarComunicado = true;                       
                        await Promise.resolve(this.formatoComunicados(respuesta.data.ComunicadosMicrositios));
                        await Promise.resolve(this.persistirSwitchArchivosActivos());
                    });
                }

            });
        },

        formatoComunicados: async function(comunicados){
          this.comunicadosFormato = comunicados.map(a => {
                let { FechaDeRegistro } = a;
                let comunicadoConFormato = a;
                comunicadoConFormato.FechaPublicacionFormato = this.formatearFecha(a.FechaDePublicacion);
                comunicadoConFormato.FechaFinDePublicacionFormato = this.formatearFecha(a.FechaFinDePublicacion);
                comunicadoConFormato.ImagenFormato = this.formatearNombreDeDocumentos(a.ImagenComunicado)
                comunicadoConFormato.ArchivoFormato =(a.TipoRuta=="RUTAINTERNA")?a.NombreDePagina:this.formatearNombreDeDocumentos(a.Ruta)
                comunicadoConFormato.EstaActivo = {
                    activo: (a.Activo == true),
                    html: `<label id="switch-activo-inactivo-MIC-${ a.ComunicadoMicrositio }" class="switch-contenido-activo-MIC">
                            <input id="check-contenido-activo-MIC-${ a.ComunicadoMicrositio }" type="checkbox">
                            <div id="slider-activo-inactivo-MIC-${ a.ComunicadoMicrositio }" class="slider-contenido-activo-MIC"></div>
                           </label>`
                };
                return comunicadoConFormato;
            });
                    this.$store.dispatch("A_SICPO_Micrositio_ComunicadosOrden",this.comunicadosFormato.filter(filtro => filtro.Activo == true && filtro.FechaPublicacionFormato<=this.formatearFecha(null) && filtro.FechaFinDePublicacionFormato>=this.formatearFecha(null)));
                    $("#tabla-comunicados").bootstrapTable({  data: this.comunicadosFormato });
                    $("#tabla-comunicados").bootstrapTable('load',  this.comunicadosFormato);
                    $('#tabla-comunicados').on('page-change.bs.table', (size, number) => {
                    this.$nextTick(async () => {
                    await Promise.resolve(this.persistirSwitchArchivosActivos());
                    });});
     

        },
        persistirSwitchArchivosActivos: async function() {
            if(this.comunicadosFormato.length > 0) {
                this.comunicadosFormato.forEach(cObj => {
                    const ID_SWITCH_ACTIVO_CONTENIDO = `check-contenido-activo-MIC-${ cObj.ComunicadoMicrositio }`;
                    $("#" + ID_SWITCH_ACTIVO_CONTENIDO).prop('checked',  cObj.EstaActivo.activo);
                });
            }
        },

        agregarAccionEditar:() => {
         return '<button id="btnEditar" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fas fa-edit"></i>&nbsp;Editar</button>';
        
        },
        llenarFormulario:function(row){
            console.log("row llenado:::::",row)
            $('#exampleModalLong').modal('show')
            this.mostrarOrdenamiento=false;
            this.mostrarFormulario=true;
            this.idComunicadoAEditar=row.ComunicadoMicrositio;
            this.titulo = row.Titulo;
            this.esEdicion = true;
            this.fechaInicio =this.formatearFecha(row.FechaDePublicacion);
            this.fechaFin = this.formatearFecha(row.FechaFinDePublicacion);
            this.tituloCampoImagen="Imagen Actual del Comunicado"
            this.nombreDeImagen = this.formatearNombreDeDocumentos(row.ImagenComunicado);
            this.estadoDeComunicado=row.Activo;
            this.visualizarEnVisor = false;
            $("#archivo-comunicado").removeClass("campo-faltante");
            $("#imagen_contenido").removeClass("campo-faltante");
            $("#texto_vinculo_contenido").removeClass("campo-faltante");
            $("#link-paginaexterna").removeClass("campo-faltante");
            $("#select-pagina").removeClass("campo-faltante");
           
            if(row.TipoRuta == "RUTAINTERNA"){
                console.log("externa:::")
            
            //  $("#pagina-micrositio").prop('checked',true);
            //  $("#descargar-documento").prop("checked",false);
             this.paginaSeleccionadaId = row.RutaInternaId;
             this.rutaPaginaMicrositio = row.RutaInternaId
             this.keySelectpagina = this.keySelectpagina +1;
             this.radioSeleccionado(2);           
            }
            else if(row.TipoRuta == "DOCUMENTO"){
             this.visualizarEnVisor = row.AbrirEnVisor;
            //  $("#descargar-documento").prop("checked",true);
             this.radioSeleccionado(1);
             this.nombreArchivo = this.formatearNombreDeDocumentos(row.Ruta);
            }
            else if(row.TipoRuta == "RUTAEXTERNA"){
            //  $("#pagina-externa").prop("checked",true);
             this.radioSeleccionado(3);
             this.paginaExterna = row.Ruta;
            }
            else if(row.TipoRuta == "NOHACERNADA"){
            //  $("#sin-accion").prop("checked",true);
             this.radioSeleccionado(4);
            }

        },

        formatearNombreDeDocumentos:function(ruta){
            var nombre =null;
            var conCaracter = (ruta!=null)?ruta.indexOf("\\"):-1;
            if(conCaracter > -1)           
            nombre = ruta.split("\\").pop();
            else if(ruta!=null && conCaracter == -1)
            nombre= ruta;
        return nombre;
        },
        
        cancelarContenido:function(row,index){
            const METODO_CAMBIAR_ESTADO = api.SICPO.sistema.micrositioweb.comunicadosmicrositios.CambiarEstadoComunicadosMicrositios;
            let peticionArchivos = false;
            let parametros={
                IdComunicado:row.ComunicadoMicrositio, 
                NuevoEstado: (row.Activo)?false:true,
                EsPrueba:false
            }
            let headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos);
            comun.SeEstaCargandoInformacion(true);           
            axios.post(api.conexion+METODO_CAMBIAR_ESTADO,parametros,headerPeticion).then((respuesta)=>{
                if(respuesta.data.SiHayError){
                     comun.SeEstaCargandoInformacion(false);
                     console.log(respuesta.data.Error);
                     comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }else{
                     comun.SeEstaCargandoInformacion(false);
                     row.Activo = (row.Activo)?false:true
                     comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                     this.obtenerComunicados();
                }

            }).catch(error => {
                comun.SeEstaCargandoInformacion(false);
                comun.mensajeDeAlerta(error, null, null);

            });
        },

formatearFecha:function(fecha){
    //2022-03-16T00:00:00
        const hoy =(fecha!=null)?new Date(fecha):new Date();
        var fechaFormateada;
        var formato = "";
        var mes = hoy.getMonth() + 1;
        var dia = hoy.getDate();

        if(mes>9 && dia>9) {
            formato = "yyyy-mm-dd";
            fechaFormateada = formato.replace('mm', hoy.getMonth() + 1).replace('yyyy', hoy.getFullYear()).replace('dd', hoy.getDate());
        }
        else if(mes>9 && dia<10) {
            formato = "yyyy-mm-0d";
            fechaFormateada = formato.replace('m', hoy.getMonth() + 1).replace('yyyy', hoy.getFullYear()).replace('d', hoy.getDate());
        }
        else if(mes<10 && dia>9){
            formato = "yyyy-0m-dd";
            fechaFormateada = formato.replace('m', hoy.getMonth() + 1).replace('yyyy', hoy.getFullYear()).replace('dd', hoy.getDate());
        }
        else if(mes<10 && dia<10) {
            formato = "yyyy-0m-0d";
            fechaFormateada = formato.replace('m', hoy.getMonth() + 1).replace('yyyy', hoy.getFullYear()).replace('d', hoy.getDate());
        }
        return fechaFormateada;

}



    },
    created() {
        this.fechaInicio = this.formatearFecha();
        this.fechaFin = this.formatearFecha();
 

         window.operateEvents = {
        'click :checkbox': (e, value, row, index) => {
            this.cancelarContenido(row,index)
         },
          'click #btnEditar':(e, value, row, index) => {         
           this.llenarFormulario(row);
     
    },

         }


    }

    

    
}
</script>
<style scoped>
.table{
    background-color: white;
}
.thead-green{
    background-color: var(--verde-pj-100);
    color: white;
}

.ver-comunicados{
    margin-top: 10px;
    margin-right: 1em; 
    text-align: right;
}
.div-select{
    margin:1em;
}
.boton-guardar{
    margin-top:1em;
    margin-bottom: 1em;
    margin-right: 1em;
    text-align: end;
 
}
.orden{
    background-color:#565758;
       align-items:right;
}
.campo-faltante{
  border: solid 1px;
  border-color: crimson;
}
   .linea-horizontal {
        margin: 0;
    }
    .caja-campos{
    margin-bottom: 1.5em !important;
    display: block !important;
}

.caja-input{
margin:1em;
}
.form-comunicado{
    font-size:1.3em;
}
.form-check-label{
    margin-left: 4px;
}
.radio{
    width: 1em;
    height: 1em;
}
 .div-opciones{
    display: flex;
    padding:25px
  }
.contenedor-form{
    margin-top:4em;
    padding-top:40px;
    padding-bottom:20px;
    background-color:var(--gris-pj-100);
    box-shadow:0px 6px 20px 4px #161616;
    padding: 25px;
    color:#161616;
}
    .linea-horizontal {
        margin: 0;
    }

    .caja-campos{
    margin-bottom: 1.5em !important;
    display: block !important;
}

</style>

<style scope>

/* SWITCH PARA INDICAR CONTENIDO ACTIVO O INACTIVO */
.switch-contenido-activo-MIC {
  position: relative;
  top: 5px;
  width: 40px;
  height: 24px;
}

/* .switch-contenido-activo-MIC input {display:none;}  */

.slider-contenido-activo-MIC {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ca2222;
  -webkit-transition: .2s;
  transition: .2s;
   border-radius: 34px;
}



.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC {
  background-color: #2ab934;
}

.switch-contenido-activo-MIC input:checked + .slider-contenido-activo-MIC:before {
  -webkit-transform: translateX(15px);
  -ms-transform: translateX(15px);
  transform: translateX(15px);
}


.slider-contenido-activo-MIC:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: .2s;
  transition: .2s;
  border-radius: 50%;
}

</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/AdministracionComunicados.vue